import { useEffect } from "react";
import {
  HELP_SECTIONS,
  type HelpSectionId,
} from "./helpContent";

export interface HelpPanelProps {
  open: boolean;
  sectionId?: HelpSectionId | null;
  onClose: () => void;
  onSelectSection: (id: HelpSectionId) => void;
}

export function HelpPanel({
  open,
  sectionId,
  onClose,
  onSelectSection,
}: HelpPanelProps) {
  const active =
    HELP_SECTIONS.find((s) => s.id === sectionId) ?? HELP_SECTIONS[0]!;

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="sm-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="sm-modal sm-help-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sm-help-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="sm-modal-head">
          <h2 id="sm-help-title">Hjælp</h2>
          <button type="button" onClick={onClose}>
            Luk
          </button>
        </header>
        <div className="sm-help-body">
          <nav className="sm-help-nav" aria-label="Vejledning">
            {HELP_SECTIONS.map((section) => (
              <button
                key={section.id}
                type="button"
                className={
                  section.id === active.id
                    ? "sm-help-nav-item is-active"
                    : "sm-help-nav-item"
                }
                onClick={() => onSelectSection(section.id)}
              >
                {section.title}
              </button>
            ))}
          </nav>
          <div className="sm-help-article">
            <h3>{active.title}</h3>
            {active.paragraphs.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
